import React from 'react';
import PropTypes from 'prop-types';
import { TwitterRound, FacebookRound, LinkedinRound, EmailRound, CopyRound } from '../../assets/icons';
import './Sharepop.scss';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { copyTextToClipboard } from '../../utils';
import { toastNotify } from '../../utils/toastNotify';

const Sharepop = (props) => {
  const { isHeader = false } = props;
  const bodyText = `Use the referral link below to receive $50 worth of shares on your initial investment into any Realbricks property.
  Get started now: `;



  return (
    <div className='sharepop'>
      <p className='fz-14 mb-0 text-taupe-80'>Share to:</p>
      <TwitterShareButton className='d-flex g-8 align-items-center sharepop__item' url={isHeader ? `${bodyText} ${localStorage.getItem('referralLink')}` : window.location.href}>
        <TwitterRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Share on Twitter</span>
      </TwitterShareButton>
      <FacebookShareButton url={isHeader ? localStorage.getItem('referralLink') : window.location.href} className='d-flex g-8 align-items-center sharepop__item'>
        <FacebookRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Share on Facebook</span>
      </FacebookShareButton>
      <LinkedinShareButton url={isHeader ? localStorage.getItem('referralLink') : window.location.href} className='d-flex g-8 align-items-center sharepop__item'>
        <LinkedinRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Share on LinkedIn</span>
      </LinkedinShareButton>
      <EmailShareButton
        url={isHeader ? `${bodyText}${localStorage.getItem('referralLink')}` : window.location.href}
        subject={isHeader ? 'Real estate investment made easy' : 'Check out this property on Realbricks'}
        // body={isHeader ? bodyText : window.location.href}
        className='d-flex g-8 align-items-center sharepop__item'
      >
        <EmailRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Send via email</span>
      </EmailShareButton>
      <a
        href={() => false}
        onClick={() => {
          copyTextToClipboard(isHeader ? localStorage.getItem('referralLink') : window.location.href);
          toastNotify('success', 'Referral Link Copied Successfully');
        }}
        className='d-flex g-8 align-items-center sharepop__item'
      >
        <CopyRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Referral Link</span>
      </a>
    </div>
  );
};

Sharepop.propTypes = {
  facebookLink: PropTypes.string,
  twitterLink: PropTypes.string,
  linkedinLink: PropTypes.string,
  emailLink: PropTypes.string,
};

export default Sharepop;
